import lazyElements from "../lazyElements/lazyElements";
// import axios from "axios";
// import lazyImages from "../lazyImages/lazyImages";
import loadJavascriptFile from "../loadJavascriptFile";
import "../contact-form";
import "./permitModal.js";
import "./copyUrl";

if (window.innerWidth > 767) { // load script for desktop
    if (!!locationPageDesktopScriptSrc) loadJavascriptFile(locationPageDesktopScriptSrc);
} else { // load script for mobile
    if (!!locationPageMobileScriptSrc) loadJavascriptFile(locationPageMobileScriptSrc);
}

/**
 * Lazy Load similar locations scripts
 */

let similarLocationScript = () => {
    if (typeof similarLocationsJs !== "undefined" && typeof similarLocationsLoaded != "undefined" && !similarLocationsLoaded) {
        loadJavascriptFile(similarLocationsJs);
        similarLocationsLoaded = true;
    }
};

let slContainer = document.getElementById("il-similar-locations");

if (slContainer) {
    new lazyElements(slContainer, similarLocationScript);
}

/**
 * Load Also Viewed Locations
 */

let alsoViewedLocationScript = () => {
    if (typeof alsoViwedLocationsJs !== "undefined" && typeof alsoViwedLocationLoaded != "undefined" && !alsoViwedLocationLoaded) {
        loadJavascriptFile(alsoViwedLocationsJs);
        alsoViwedLocationLoaded = true;
    }
};

let avlContainer = document.getElementById("il-also-viewed-locations");

if (avlContainer) {
    new lazyElements(avlContainer, alsoViewedLocationScript);
}

/**
 * Load Nearby Locations
 */
let nearbyLocationsScript = () => {
    if (typeof nearbyLocationsJs !== "undefined" && typeof nearbyLocationLoaded != "undefined" && !nearbyLocationLoaded) {
        loadJavascriptFile(nearbyLocationsJs);
        nearbyLocationLoaded = true;
    }
};

let nlContainer = document.getElementById("il-nearby-locations");

if (nlContainer) {
    new lazyElements(nlContainer, nearbyLocationsScript);
}

/**
 * Load Thumb Gallery script on button click.
 */

let thumbGalleryTrigger = document.querySelectorAll('.il-thumbnails-btn');
let thumbGalleryScriptLoaded = false;
thumbGalleryTrigger.forEach(btn => {
    btn.addEventListener('click', (e) => {
        if (typeof thumbGalleryScript !== "undefined" && typeof thumbGalleryScript != "undefined" && !thumbGalleryScriptLoaded) {
            loadJavascriptFile(thumbGalleryScript);
            thumbGalleryScriptLoaded = true;
        }
    })
});

//  loadJavascriptFile(alsoViwedLocationsJs);



